import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.cui-floating-panel-menu__container{display:contents;position:relative}`);